var DesignerConsts = /** @class */ (function () {
    function DesignerConsts() {
    }
    DesignerConsts.events = {
        viewSizeChanged: 'designer:view-size-changed',
        modelChanged: 'designer:model-changed'
    };
    return DesignerConsts;
}());
export { DesignerConsts };
